(function () {
  'use strict';

  var win = window;
  var doc = document;
  var blockedKeyPattern = /(email|phone|tel|name|address|message|body|postal|zip|company|customer)/i;
  var phonePattern = /(?:\+?1[\s.-]?)?(?:\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}/;
  var debug = /[?&]tcg_events_debug=1(?:&|$)/.test(win.location.search) || win.localStorage.getItem('tcg_events_debug') === '1';
  var previousTrack = typeof win.tcgTrackEvent === 'function' ? win.tcgTrackEvent : null;
  var queuedEvents = Array.isArray(win.tcgEventQueue) ? win.tcgEventQueue.slice() : [];
  var googleAdsConfig = win.tcgGoogleAdsConfig || {};
  var primaryLeadEvents = {
    lead_submit_container_purchase_rfq: 'container_purchase_rfq',
    lead_submit_rental_request_rfq: 'rental_request_rfq',
    lead_submit_book_rental_now: 'book_rental_now',
    lead_submit_mods_quote: 'mods_quote',
    lead_submit_mods_questionnaire: 'mods_questionnaire',
    lead_submit_3d_rfq_tool: '3d_rfq_tool',
    lead_submit_planmycan: 'planmycan'
  };

  win.dataLayer = win.dataLayer || [];
  win.__tcgEvents = win.__tcgEvents || [];

  function normalizeName(name) {
    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 80);
  }

  function safeKey(key) {
    return String(key || '')
      .trim()
      .replace(/[^a-zA-Z0-9_]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 80);
  }

  function safeValue(value) {
    if (value == null) return value;
    if (typeof value === 'number' || typeof value === 'boolean') return value;
    if (Array.isArray(value)) return value.slice(0, 12).map(safeValue);
    if (typeof value === 'object') return sanitizeParams(value);

    var text = String(value).trim();
    if (!text) return '';
    if (text.indexOf('@') !== -1 || phonePattern.test(text)) return '[redacted]';
    return text.slice(0, 160);
  }

  function sanitizeParams(params) {
    var clean = {};
    Object.keys(params || {}).forEach(function (key) {
      if (blockedKeyPattern.test(key)) return;
      var safe = safeKey(key);
      if (!safe) return;
      clean[safe] = safeValue(params[key]);
    });
    return clean;
  }

  function shouldSkipOnce(onceKey) {
    if (!onceKey) return false;
    var storageKey = 'tcg_event_once_' + String(onceKey).slice(0, 160);
    try {
      if (win.sessionStorage.getItem(storageKey)) return true;
      win.sessionStorage.setItem(storageKey, '1');
    } catch (error) {
      return false;
    }
    return false;
  }

  function shouldSkipGoogleAdsOnce(eventName, payload) {
    var basis = eventName + ':' + (payload.lead_type || payload.request_type || payload.form_type || win.location.pathname);
    var storageKey = 'tcg_google_ads_once_' + basis.slice(0, 160);
    try {
      if (win.sessionStorage.getItem(storageKey)) return true;
      win.sessionStorage.setItem(storageKey, '1');
    } catch (error) {
      return false;
    }
    return false;
  }

  function canSendGoogleAdsConversion() {
    if (!googleAdsConfig.primaryLeadSendTo || typeof win.gtag !== 'function') return false;
    if (win.Shopify && win.Shopify.designMode) return false;
    if (/[?&](preview_theme_id|tcg_disable_ads=1)(?:&|$)/.test(win.location.search)) return false;
    return true;
  }

  function sendGoogleAdsLeadConversion(eventName, payload) {
    var leadType = primaryLeadEvents[eventName];
    if (!leadType || !canSendGoogleAdsConversion()) return;
    if (shouldSkipGoogleAdsOnce(eventName, payload)) return;

    var conversionPayload = {
      send_to: googleAdsConfig.primaryLeadSendTo,
      value: Number(googleAdsConfig.leadValue || 3),
      currency: googleAdsConfig.currency || 'CAD',
      event_timeout: 2000,
      transport_type: 'beacon',
      tcg_event: eventName,
      lead_type: leadType
    };

    win.gtag('event', 'conversion', conversionPayload);

    if (debug && win.console && typeof win.console.info === 'function') {
      win.console.info('[TCG Google Ads conversion]', eventName, conversionPayload);
    }
  }

  function track(name, params, options) {
    var eventName = normalizeName(name);
    if (!eventName) return false;

    options = options || {};
    if (shouldSkipOnce(options.onceKey)) return false;

    var payload = sanitizeParams(params || {});
    payload.event = eventName;
    payload.tcg_event = eventName;

    win.dataLayer.push(payload);
    win.__tcgEvents.push({
      name: eventName,
      params: payload,
      at: new Date().toISOString()
    });

    doc.dispatchEvent(new CustomEvent('tcg:event', {
      detail: {
        name: eventName,
        params: payload
      }
    }));

    if (debug && win.console && typeof win.console.info === 'function') {
      win.console.info('[TCG event]', eventName, payload);
    }

    sendGoogleAdsLeadConversion(eventName, payload);

    return true;
  }

  function surfaceForElement(element) {
    if (!element || !element.closest) return 'site';
    if (element.closest('header, .shopify-section-header, .header, #shopify-section-header')) return 'header';
    if (element.closest('footer, .shopify-section-footer, .footer, #shopify-section-footer')) return 'footer';
    if (element.closest('[data-tcg-thankyou]')) return 'thank_you';
    if (element.closest('[data-tcg-catalogue]')) return 'parts_hub';
    if (element.closest('[data-tcg-featured-parts]')) return 'popular_accessories';
    return 'page';
  }

  function linkPath(href) {
    if (!href) return '';
    try {
      var url = new URL(href, win.location.origin);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return String(href).slice(0, 160);
    }
  }

  function bindIntentSignals() {
    doc.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form')) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/search') === -1 && action.indexOf('search') === -1) return;

      var query = form.querySelector('input[name="q"], input[type="search"], input[name="query"]');
      var value = query ? query.value : '';
      if (!value) return;

      track('site_search', {
        search_term: value,
        search_surface: surfaceForElement(form)
      });
    }, true);

    doc.addEventListener('click', function (event) {
      var target = event.target && event.target.closest && event.target.closest('a, button');
      if (!target) return;

      var href = target.getAttribute('href') || target.dataset.href || '';
      var label = (target.innerText || target.getAttribute('aria-label') || '').trim().replace(/\s+/g, ' ');
      var lower = (href + ' ' + label).toLowerCase();
      var isQuoteIntent = lower.indexOf('quote') !== -1 || lower.indexOf('rfq') !== -1 || lower.indexOf('request') !== -1;
      if (!isQuoteIntent) return;

      var eventName = lower.indexOf('/pages/rfq') !== -1 || lower.indexOf('rfq') !== -1 ? 'rfq_route_click' : 'quote_cta_click';
      track(eventName, {
        cta_label: label,
        cta_surface: surfaceForElement(target),
        link_path: linkPath(href)
      });
    }, true);
  }

  win.tcgTrackEvent = track;
  win.tcgEventBridgeReady = true;
  bindIntentSignals();

  queuedEvents.forEach(function (queued) {
    if (!queued || !queued.name) return;
    track(queued.name, queued.params || {}, queued.options || {});
  });

  if (previousTrack && previousTrack !== track && previousTrack._tcgPreserve) {
    previousTrack();
  }
}());
